export enum CourseActionTypes {
  API_RESPONSE_SUCCESS = "@@course/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@course/API_RESPONSE_ERROR",

  CREATE_COURSE = "@@course/CREATE_COURSE",
  GET_COURSE = "@@course/GET_COURSE",
  UPDATE_COURSE = "@@course/UPDATE_COURSE",
  UPDATE_COURSE_ENROLLMENT = "@@course/UPDATE_COURSE_ENROLLMENT",
  DELETE_COURSE = "@@course/DELETE_COURSE",
}